/* eslint class-methods-use-this: 0 */
import moment from 'moment';
import TettraResourceAbstractSchema from './TettraResourceAbstractSchema';
import { ICON, RESOURCE_TYPE } from '../utilities/CONSTANTS';
import { INLINE_REFERENCE_TYPE } from '../tettra-editor/utilities/CONSTANTS';
import { getGoogleDriveIcon } from '../utilities/inlineReferenceUtilities';

// Example
// {
//     "id": "1dG_Gv4Bq9uMZ7XR3EjR9xX85yvqqcKl2eXCGZJIjLDE",
//     "name": "Tettra Proposal - NextGen",
//     "mimeType": "application/vnd.google-apps.document",
//     "webViewLink": "https://docs.google.com/document/d/1dG_Gv4Bq9uMZ7XR3EjR9xX85yvqqcKl2eXCGZJIjLDE/edit?usp=drivesdk",
//     "iconLink": "https://drive-thirdparty.googleusercontent.com/16/type/application/vnd.google-apps.document",
//     "createdTime": "2021-11-03T18:51:41.317Z",
//     "modifiedTime": "2021-11-03T19:04:27.081Z"
// }

class GoogleDrive extends TettraResourceAbstractSchema {
    constructor(data) {
        super(data);
        this.data = this.constructor.transformData(data);
        this.id = this.data.id;
        this.type = RESOURCE_TYPE.GOOGLE_DOCS;
    }

    static transformData(data) {
        const {
            id,
            name: title,
            webViewLink: url,
            mimeType,
            iconLink,
            modifiedTime: modifiedAt,
            createdTime: createdAt,
        } = data;

        return ({
            id, title, url, mimeType, iconLink, modifiedAt, createdAt,
        });
    }

    getId() {
        return this.id;
    }

    getTitle() {
        return this.data.title;
    }

    getSubtitle() {
        return moment(this.data.modifiedAt).fromNow();
    }

    getIcon() {
        return this.data.iconLink || ICON.GOOGLE_DRIVE;
    }

    getCustomClass() {
        return 'google-drive';
    }

    getUrl() {
        return this.data.url;
    }

    getFontIcon() {
        return getGoogleDriveIcon(this.data.mimeType);
    }

    getEntityData() {
        const referenceType = INLINE_REFERENCE_TYPE.GOOGLE_DOC;
        const {
            id, title, url, mimeType, iconLink, modifiedAt, createdAt,
        } = this.data;

        return ({
            referenceType,
            title,
            url,
            id,
            metadata: {
                mimeType,
                iconLink,
                modifiedAt,
                createdAt,
            },
        });
    }

    isInternal() {
        return false;
    }
}

export default GoogleDrive;
